// extracted by mini-css-extract-plugin
module.exports = {"btn":"RegisterButton_btn__3_fn9","tvprtch":"RegisterButton_tvprtch__C6HeR"};